export default __webpack_public_path__ + "static/media/logo_ecoglass_horizontal.df48094e.png";